export const NO_AVAILABILITY_MESSAGE =
  'The current configuration of this section will result in it not being published. Manage its availability to choose where it should appear.';

export const NO_CHANNEL_AVAILABILITY_MESSAGE =
  "This section has no channel availability and won't be published to any channel. Manage its availability to choose where it should appear.";

export const NO_VENUE_AVAILABILITY_MESSAGE =
  "This section has no venue availability and won't be published to any venues. Manage its availability to choose where it should appear.";

// A card only has to pass over a collapsed section on its way elsewhere, so the section waits
// for the pointer to settle before opening rather than shifting the page out from under it.
export const DRAG_HOVER_EXPAND_DELAY_MS = 400;
